module.exports = __webpack_public_path__ + "img/header-logo.8597459.png";